import { render, staticRenderFns } from "./GeneralScrollTable.vue?vue&type=template&id=151ac11e&scoped=true&"
import script from "./GeneralScrollTable.vue?vue&type=script&lang=js&"
export * from "./GeneralScrollTable.vue?vue&type=script&lang=js&"
import style0 from "./GeneralScrollTable.vue?vue&type=style&index=0&id=151ac11e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151ac11e",
  null
  
)

export default component.exports